import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "common_table custom_scroll" }
const _hoisted_2 = { class: "common_table custom_scroll _700" }
const _hoisted_3 = { class: "areaTable" }
const _hoisted_4 = { style: {"background-color":"#f5f5f5"} }
const _hoisted_5 = { class: "graph_wrap" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PageBtn = _resolveComponent("PageBtn")!
  const _component_Chart = _resolveComponent("Chart")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("table", _hoisted_3, [
        _cache[1] || (_cache[1] = _createElementVNode("colgroup", null, [
          _createElementVNode("col", { style: {"max-width":"350px"} }),
          _createElementVNode("col", { style: {"max-width":"350px"} })
        ], -1)),
        _cache[2] || (_cache[2] = _createElementVNode("thead", { class: "left" }, [
          _createElementVNode("tr", null, [
            _createElementVNode("th", null, "날짜"),
            _createElementVNode("th", null, "접속자")
          ])
        ], -1)),
        _createElementVNode("tbody", null, [
          _createElementVNode("tr", _hoisted_4, [
            _cache[0] || (_cache[0] = _createElementVNode("td", null, "총 접속자", -1)),
            _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.state.sum)), 1)
          ]),
          ($setup.state.list.length > 0)
            ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList($setup.state.list, (item, idx) => {
                return (_openBlock(), _createElementBlock("tr", { key: idx }, [
                  _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.dateFormatYYMMDD(item.targetCol, ".")), 1),
                  _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat(item.cnt)), 1)
                ]))
              }), 128))
            : _createCommentVNode("", true)
        ])
      ]),
      ($setup.state.list.length !== 0)
        ? (_openBlock(), _createBlock(_component_PageBtn, {
            key: 0,
            currentPage: $setup.state.page,
            totalLength: $setup.state.totalLength,
            perPage: $setup.state.size,
            onOnPaging: $setup.handlePageChange
          }, null, 8, ["currentPage", "totalLength", "perPage", "onOnPaging"]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_5, [
      ($setup.visitHistoryState.isDraw)
        ? (_openBlock(), _createBlock(_component_Chart, {
            key: 0,
            titlePadding: $setup.visitHistoryState.titlePadding,
            data: $setup.visitHistoryState.data,
            legendPosition: $setup.visitHistoryState.legendPosition,
            width: $setup.visitHistoryState.chartWidth,
            height: $setup.visitHistoryState.chartHeight,
            title: $setup.visitHistoryState.title,
            subTitle: $setup.visitHistoryState.subTitle
          }, null, 8, ["titlePadding", "data", "legendPosition", "width", "height", "title", "subTitle"]))
        : _createCommentVNode("", true)
    ])
  ]))
}